import Modal from 'react-modal'
import UndiruvchiDashboardModalStyle from './UndiruvchiDashboardModalStyle'
import { useEffect, useState } from 'react'
import { customFuncsApi } from '../../../api'
import { useSelector } from 'react-redux'
import Spinner from '../../Spinner'
import numberWithSpaces from '../../../helpers/numberWithSpaces'
import { useNavigate } from 'react-router-dom'

const customStyles = {
	content: {
		top: '50%',
		left: '50%',
		right: 'auto',
		bottom: 'auto',
		marginRight: '-50%',
		transform: 'translate(-50%, -50%)',
		borderRadius: 15,
		border: 'none',
		overflowX: 'auto',
		...(window.innerWidth <= 640 ? { height: '90%' } : {}),
		zIndex: 1000,
	},
	overlay: {
		background: '#00000099',
		zIndex: 1000,
	},
}
const UndiruvchiDashboardModal = ({
	isOpenModal,
	setIsOpenModal,
	modalTitle,
	endpoint,
}) => {
	const { getMe } = useSelector((state) => state.main)
	const navigate = useNavigate()

	const [isLoading, setIsLoading] = useState(false)
	const [data, setData] = useState([])
	const [zeroPaidCount, setZeroPaidCount] = useState(0)
	const [paidCount, setPaidCount] = useState(0)

	useEffect(() => {
		setIsLoading(true)
		customFuncsApi
			.get(endpoint, {
				params: {
					U_Dunner: endpoint.includes('U_Dunner')
						? undefined
						: getMe.EmployeeID,
				},
			})
			.then((res) => {
				setData(res.data.value || [])
				const zeroPaid = res.data.value.filter(
					(item) => item.PaidSum === 0,
				).length
				const paid = res.data.value.filter((item) => item.PaidSum > 0).length
				setZeroPaidCount(zeroPaid)
				setPaidCount(paid)
			})
			.catch(() => {
				alert('Ошибка при получении данных')
			})
			.finally(() => setIsLoading(false))
	}, [endpoint])

	const viewItem = (v) => {
		navigate('/viewRecoveryItem', {
			state: {
				data: v,
				isTask: true,
			},
		})
	}

	return (
		<Modal
			isOpen={isOpenModal}
			onRequestClose={() => setIsOpenModal(false)}
			style={customStyles}
			contentLabel="Example Modal"
			ariaHideApp={false}
		>
			<UndiruvchiDashboardModalStyle>
				<div className="card">
					<p className="title">{modalTitle}</p>
				</div>
				{isLoading ? (
					<Spinner />
				) : (
					<div className="overflow-auto max-h-[calc(60vh)]">
						<table className="w-full border-collapse bg-white text-sm">
							<thead>
								<tr className="bg-gray-50">
									<th className="border border-gray-200 px-3 py-2 text-left font-medium text-gray-600 text-xs uppercase">
										Код Клиента
									</th>
									<th className="border border-gray-200 px-3 py-2 text-left font-medium text-gray-600 text-xs uppercase">
										Имя Клиента
									</th>
									<th className="border border-gray-200 px-3 py-2 text-left font-medium text-gray-600 text-xs uppercase">
										Сумма оплаты
									</th>
									<th className="border border-gray-200 px-3 py-2 text-left font-medium text-gray-600 text-xs uppercase">
										Imei
									</th>
								</tr>
							</thead>
							<tbody>
								{data.map((row, index) => (
									<tr
										key={index}
										className="bg-white hover:bg-gray-100 cursor-pointer transition-colors"
										onClick={() => {
											viewItem(row)
										}}
									>
										<td className="border border-gray-200 px-3 py-2">
											{row.CardCode || '—'}
										</td>
										<td className="border border-gray-200 px-3 py-2">
											{row.CardName || '—'}
										</td>
										<td className="border border-gray-200 px-3 py-2">
											${numberWithSpaces(row.PaidSum)}
										</td>
										<td className="border border-gray-200 px-3 py-2">
											{row?.IntrSerial || '—'}
										</td>
									</tr>
								))}
							</tbody>
						</table>
						<div className="space-y-2">
							<div className="h-10 w-full mt-4 flex rounded-lg overflow-hidden border">
								<div className="flex-1 bg-red-50 text-red-700 flex items-center justify-center font-semibold">
									Umuman to'lanmagan: {zeroPaidCount}
								</div>
								<div className="flex-1 bg-green-50 text-green-700 flex items-center justify-center font-semibold">
									To'langan: {paidCount}
								</div>
							</div>
						</div>
					</div>
				)}
			</UndiruvchiDashboardModalStyle>
		</Modal>
	)
}

export default UndiruvchiDashboardModal
